import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import Amount from 'design-system/Amount';
import { getBalance } from 'utils/api/getBalance';
const RowAccountBalance = ({ data, primaryBalanceOnly, small, forceScramble, }) => {
    const [firstBalance, convertedBalance] = getBalance(data);
    const cryptoBalance = data.type === 'CRYPTO' && firstBalance && convertedBalance
        ? firstBalance
        : null;
    const isCrypto = cryptoBalance !== null;
    const primaryBalance = isCrypto ? convertedBalance : firstBalance;
    const secondBalance = cryptoBalance
        ? { value: cryptoBalance.amount }
        : convertedBalance;
    return (<View style={isCrypto
            ? [styles.balanceView, styles.cryptoBalanceView]
            : styles.balanceView}>
      {primaryBalance !== null && (<Amount {...(small ? { 'Numbers-14': true } : { 'Numbers-16': true })} OffBlack forceScramble={forceScramble} value={primaryBalance}/>)}
      {!primaryBalanceOnly && (<View style={styles.secondBalanceContainer}>
          {secondBalance !== null && (<Amount NumbersThin-14 Gray value={secondBalance} forceScramble={forceScramble} {...(isCrypto && {
                fractionDigits: null,
                numberOfLines: 1,
                ellipsizeMode: 'tail',
            })}/>)}
        </View>)}
    </View>);
};
const styles = StyleSheet.create({
    balanceView: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    cryptoBalanceView: {
        maxWidth: '50%',
        alignItems: 'flex-end',
    },
    secondBalanceContainer: {
        alignSelf: 'flex-end',
        alignItems: 'flex-end',
    },
});
export default memo(RowAccountBalance);
